import { BaseService } from '../../infra/base.service'
import type { Appointment } from './appointment'
import type { AppointmentsRepository } from './appointments.repository'
import type { SignAppointment } from './dto/sign-appointment.dto'

export class AppointmentsService extends BaseService<Appointment> {
    constructor(private rep: AppointmentsRepository) {
        super(rep)
    }

    async getNextAppointmentFromPerson(personId: string, time: string = null) {
        return await this.rep.getNextAppointmentFromPerson(personId, time)
    }

    async getSugestions(personId: string, scheduleId: string) {
        return await this.rep.getSugestions(personId, scheduleId)
    }

    async getComissions(params?: { page?: number; from?: Date; to?: Date; query?: string } | any) {
        return await this.rep.getComissions(params)
    }

    async comissionsChangeStatus(appointmentItemId: string, active: boolean) {
        return await this.rep.comissionsChangeStatus(appointmentItemId, active)
    }

    async setItemInvoice(appointmentItemId: string, invoiceId: string | null) {
        return await this.rep.setItemInvoice(appointmentItemId, invoiceId)
    }

    async comissionsUpdate(params?: { appointmentId?: string; invoiceId?: string } | any) {
        return await this.rep.comissionsUpdate(params)
    }

    async comissionsRecalculate(params: { from: Date; to: Date; comissionSource: string }) {
        return await this.rep.comissionsRecalculate(params)
    }

    async changeStatus(appointmentId: string, dto) {
        return await this.rep.changeStatus(appointmentId, dto)
    }

    async publicChangeStatus(personId: string, appointmentId: string, dto) {
        return await this.rep.publicChangeStatus(personId, appointmentId, dto)
    }

    async getConsulting(from: Date, to: Date, consultingServicesId, fromCreatedAt = false) {
        return await this.rep.getConsulting(from, to, consultingServicesId, fromCreatedAt)
    }

    async setPaid(
        appointmentId: string,
        dto: { invoiceId: string; comissionSource: string; voidComission: boolean; status?: string },
    ) {
        return await this.rep.setPaid(appointmentId, dto)
    }

    async setUnpaid(appointmentId: string) {
        return await this.rep.setUnpaid(appointmentId)
    }

    async sign(appointmentId: string, signatureBase64: string): Promise<SignAppointment> {
        return await this.rep.sign(appointmentId, signatureBase64)
    }

    async getAllFromPersons(personsId: string[]) {
        //
        let promises = []
        for (let i = 0; i < personsId.length; i += 100) {
            const chunk = personsId.slice(i, i + 100)
            promises.push(this.getAll({ personId: chunk.join(',') }))
        }
        const results = await Promise.all(promises)
        let appointments: Appointment[] = []
        for (const result of results) {
            appointments = appointments.concat(result)
        }
        return appointments
    }
}
